import { render, staticRenderFns } from "./reseller-balance-settlement.vue?vue&type=template&id=34c72dc4&"
import script from "./reseller-balance-settlement.vue?vue&type=script&lang=js&"
export * from "./reseller-balance-settlement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports